import React from 'react';
import { RadioField } from '@zola/zola-ui/src/components/Form/RadioFieldV2/RadioField';
import {
  SORT_DEFAULT,
  SORT_OPTIONS,
} from 'cards/components/CardListing/CardListingRedesign/constants';

import { getSortLabel } from '../utils';
import { CommonFilterProps } from './types';
import { FilterBase, FilterOption } from './FilterBase';

export const FilterSortBy: React.FC<CommonFilterProps> = ({
  activeFilter,
  updateFilter,
  searchFilters,
}) => {
  const [activedSort] = searchFilters.sorts?.length ? searchFilters.sorts : [SORT_DEFAULT];

  return (
    <FilterBase
      filterLabel="Sort"
      activeFilter={activeFilter}
      filterSelectedOptions={getSortLabel(searchFilters.sorts)}
    >
      {SORT_OPTIONS.map(({ value, label }) => (
        <FilterOption key={value}>
          <RadioField
            checked={value === activedSort}
            id={value}
            label={label}
            onChange={() => updateFilter('sorts', value === SORT_DEFAULT ? [] : [value])}
          />
        </FilterOption>
      ))}
    </FilterBase>
  );
};
